import '../styles/bootstrap-custom'
import '../styles/root-globals.scss'
import './index.scss'
import React from 'react'
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

import * as Sentry from '@sentry/react'
import axios from 'axios'
import { createRoot } from 'react-dom/client'

import App from './App'

const env = process.env.NODE_ENV as 'production' | 'demo' | 'staging' | 'prerelease'

if (!window.Cypress && ['production', 'staging', 'demo', 'prerelease'].includes(env ?? '')) {
  Sentry.init({
    release: __PP_SENTRY_RELEASE__ || undefined,
    environment: env === 'production' ? 'production' : env === 'prerelease' ? 'prerelease' : 'staging',
    dsn: 'https://2c5c4e160916dd404b7011137fd9a724@o525650.ingest.sentry.io/4506396554887168',
    sendDefaultPii: true,
    enableLogs: true,
    integrations: [
      // Version-independent integration (React Router v6+), so router upgrades need no Sentry change
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      ...(env === 'production'
        ? [
            Sentry.replayIntegration({
              beforeErrorSampling(event) {
                // Check if the event is an error event
                if (event.exception) {
                  // Check if the event has a 404 error
                  const requestErrors = event.exception?.values?.filter(
                    (value) => value.type === 'Error' && value?.value?.includes('404'),
                  )

                  // If there is a 404 error, return false to filter it out
                  if ((requestErrors?.length ?? 0) > 0) {
                    return false
                  }
                }

                // Otherwise, allow the error to be sampled
                return true
              },
            }),
          ]
        : []),
    ],
    tracePropagationTargets: ['localhost', /^https:\/\/provider\.(staging\.)?lyrahealth\.com\/api/],
    tracesSampleRate: 0.002,
    beforeSend(event, hint) {
      const error = hint?.originalException
      if (
        axios.isAxiosError(error) &&
        error.response &&
        (error.response.status === 401 || error.response.status === 404)
      ) {
        // filter out 4xx errors
        return null
      }
      return event
    },
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  })
}

export const SentryRoutes = Sentry.wrapReactRouterRouting(Routes)
export const sentryCreateBrowserRouter: typeof createBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter)

// @ts-expect-error TS(2345): Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
const root = createRoot(document.getElementById('root'))

window.onload = function () {
  root.render(<App />)
  // if ('serviceWorker' in navigator) {
  //   navigator.serviceWorker.register('/service-worker.js')
  // }
}
